export function StatusCard({
  label,
  value,
  tone = "default",
}: {
  label: string;
  value: number | string;
  tone?: "default" | "primary" | "success" | "danger" | "warning";
}) {
  const toneColor: Record<string, string> = {
    default: "var(--color-text)",
    primary: "var(--color-primary)",
    success: "var(--color-success)",
    danger: "var(--color-danger)",
    warning: "var(--color-warning)",
  };
  return (
    <div className="stat-card">
      <div className="stat-value" style={{ color: toneColor[tone] }}>
        {value}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
}
